import React, {Component} from 'react'
import BatchesMarkTransferred from './BatchesMarkTransferred'

class BatchesMarkTransferredContainer extends Component {
    render() {
        return (
            <div className='BatchesMarkTransferredContainer p-5'>
                <div className='row'>
                    <div className='col-12 mx-auto'>
                        <h1>Đánh dấu đã ép</h1>
                        <BatchesMarkTransferred/>
                    </div>
                </div>
            </div>
        )
    }

}

export default BatchesMarkTransferredContainer